import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class ChannelCreationError extends CodedError {
  static get errorName() {
    return errorCodes.channelCreationError.code;
  }

  constructor(message: string = errorCodes.channelCreationError.message) {
    super(message);
    this.code = errorCodes.channelCreationError.code;
    this.message = `${message} ${errorCodes.channelCreationError.code}`;
    this.name = errorCodes.channelCreationError.name;
  }
}
